<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication" id="dedication"><a id="page_v"></a><em>To my father, for quiet wisdom and integrity,<br/>and for respecting me as an adult<br/>long before I was one.</em></p>
<p class="noindent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1faf0a1d